const pkg = require('../../package.json');

export const { version } = pkg;
